import React, { useEffect, useState } from "react";
import TitlePageTotvs from "../../../components/TitlePageTotvs";
import LoadingSpinner from "../../../components/LoadinSpinner";
import InputGeral from "../../../components/InputGeral/Index";
import SelectDinamico from "../../../components/SelectDinamico";
import SelectContaContabil from "../../../components/Select/ContaContabil";
import SelectCentroCusto from "../../../components/Select/CentroCusto";
import SelectArmazem from "../../../components/Select/Armazem";
import SelectFixo from "../../../components/SelectFixo";
import UploadFiles from "../../../components/UploadFiles";
import TrelloBoard from "../../../components/TrelloBoard";
import SubmitForm from "../../../components/SubmitForm";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import { format, parse } from "date-fns";

import PedidoItens from "../../../../lib/json/consultas/PedidoItens.json"
import Solicitacao from "../../../../lib/json/consultas/Solicitacao.json"
import ConsultaCentroCusto from "../../../../lib/json/consultas/CentroCustoSelect.json"
import ConsultaContaContabil from "../../../../lib/json/consultas/ContaContabil.json"

import { ConsumoAPI_FileUpload } from "../../../../backend/ConsumoAPI";
import { ErroMsg, RetornaUsuarioLogado, SucessoMsg, calcularDiferencaEmDias, converteDataProtheus, formatDateColumnCard, formatarComoDecimal, formatarMoeda2, optionsStatusSC, parseLocaleNumber } from "../../../contents/VariaveisGlobais";
import ConsultaTotvs from "../../../../backend/ConsultaTotvs";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import BuscaProduto from "../../../components/BuscaProduto";
import { LabelInput } from "../../../components/InputGeral/styles";
import { HRDivider } from "../../CRM/Cadastros/FichaEtapa/styles";
import SelectFinalidade from "../../../components/Select/Finalidade";
import { handleQtdUnitario, handleValorTotal, handleObservacaoInterna, handleAnexos } from "../../../components/GridCell/Solicitacao";
import SelectFornecedor from "../../../components/Select/Fornecedor";
import SelectComprador from "../../../components/Select/Comprador";
import SelectCondicaoPagamento from "../../../components/Select/CondicaoPagamento";
import SelectMoeda from "../../../components/Select/Moeda";
import { usePopUp } from "../../../components/BootBox";
import SelecaoSolicitacaoCompra from "../../../components/SelecaoSolicitacaoCompra";
import { ConsultaTotvsEmpresa } from "../../../../backend/ConsultaTotvsEmpresa";
import { DEFAULT_BREAKPOINTS } from "react-bootstrap/esm/ThemeProvider";
import { handleCentroCustoLabel, handleQtd, handleSolicCompra, handleUMedidaQtd, handleValorTotalPCCard, handleValorUnitarioCard } from "../../../components/GridCell/Pedido";

function FichaPedidosCompra({idPedidoCompra: propIdPedidoCompra,
  empresaFilialCompras: propEmpresaFilialCompras,
  empresaFilialDestino: propEmpresaFilialDestino,
}){
    const navigate = useNavigate();
    const currentDate = new Date()
    const isFormVisual = window.location.href.includes('Visualizar') || propIdPedidoCompra;
    const isCopiar = window.location.href.includes('Copiar');
    
    const usuarioLogado = RetornaUsuarioLogado()
    const usuarioProtheus = usuarioLogado.usuarioProtheus

    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    // const { idPedidoCompra, empresaFilialCompras, empresaFilialDestino } = useParams();
    const {
        idPedidoCompra: urlId,
        empresaFilialCompras: urlEmpresaFilial,
        empresaFilialDestino: urlDestino
    } = useParams();

    // Use prop se existir, senão use o valor da URL
    const idPedidoCompra = propIdPedidoCompra ?? urlId;
    const empresaFilialCompras = propEmpresaFilialCompras ?? urlEmpresaFilial;
    const empresaFilialDestino = propEmpresaFilialDestino ?? urlDestino;

    const [carregar, setCarregar] = useState(false);
    const [habilitaItem, setHabilitaItem] = useState(false);
    const [disabledForm, setDisabledForm] = useState(isFormVisual);
    const [empresaFilial, setEmpresaFilial] = useState();
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState();
    
    const [diasSLA, setDiasSLA] = useState(0);
    const [campoDataNecessidade, setCampoDataNecessidade] = useState("");

    //Campos Novos
    const [campoNumero, setCampoNumero] = useState( isCopiar ? "" : idPedidoCompra );
    const [campoFornecedor, setCampoFornecedor] = useState();
    const [campoDataEmissao, setCampoDataEmissao] = useState(format(currentDate, 'yyyy-MM-dd'));
    const [campoComprador, setCampoComprador] = useState({value: usuarioProtheus?.value || '', label: ''});
    const [disabledComprador, setDisabledComprador] = useState(!usuarioLogado.permissao.visualizarPedidoCompra)
    const [campoTipoCompra, setCampoTipoCompra] = useState({value: '', label: 'Selecione a Finalidade'});
    const [campoPrioridade, setCampoPrioridade] = useState({value: '', text: 'Selecione a Prioridade' });
    const [campoCondicaoPagamento, setCampoCondicaoPagamento] = useState();
    const [campoEnviaEmail, setCampoEnviaEmail] = useState({value: ' ', text: 'Enviar'});
    const [campoMoeda, setCampoMoeda] = useState({value: '', label: 'Selecione a Moeda'});
    const [campoJustificativaComprador, setCampoJustificativaComprador] = useState("");
    const [campoObservacaoFornecedor, setCampoObservacaoFornecedor] = useState("");
    const [campoAnexos, setCampoAnexos] = useState([]);
    const [campoDesconto,  setCampoDesconto] = useState(formatarMoeda2(0,4));
    const [campoValorDesconto, setCampoValorDesconto] = useState(0);
    const [campoTipoFrete, setCampoTipoFrete] = useState({value: 'C', text: 'CIF'});
    const [campoValorFrete, setCampoValorFrete] = useState(formatarMoeda2(0,2));
    
    const [campoItem, setCampoItem] = useState();
    const [campoProduto, setCampoProduto] = useState();
    const [campoUnidade, setCampoUnidade] = useState();
    const [campoDescricaoComplementar, setCampoDescricaoComplementar] = useState('');
    const [campoQuantidade, setCampoQuantidade] = useState();
    const [campoNumeroNF, setCampoNumeroNF] = useState('');
    const [campoCA, setCampoCA] = useState('');
    const [campoValorUnitario, setCampoValorUnitario] = useState(formatarMoeda2(0,4));
    const [campoValorTotal, setCampoValorTotal] = useState(formatarMoeda2(0,2));
    const [campoValorTotalProdutos,setCampoValorTotalProdutos] = useState(0);
    const [campoArmazem, setCampoArmazem] = useState();
    const [campoContaContabil, setCampoContaContabil] = useState();
    const [campoCentroCusto, setCampoCentroCusto] = useState();
    const [campoCentroCustoReposicao, setCampoCentroCustoReposicao] = useState();
    const [campoEnderecoEntrega, setCampoEnderecoEntrega] = useState();
    const [campoAnexosItem, setCampoAnexosItem] = useState([]);
    
    const [campoTotalICMS, setCampoTotalICMS] =useState(0);
    const [campoTotalIPI, setCampoTotalIPI] =useState(0);
    const [campoTotalPIS, setCampoTotalPIS] =useState(0);
    const [campoTotalCOFINS, setCampoTotalCOFINS] =useState(0);
    const [campoTotalISS, setCampoTotalISS] =useState(0);
    const [campoTotalIRRF, setCampoTotalIRRF] =useState(0);
    const [campoTotalINSS, setCampoTotalINSS] =useState(0);
    const [campoTotalCSLL, setCampoTotalCSLL] =useState(0);
    const [campoTotalDIFAL, setCampoTotalDIFAL] =useState(0);
    const [campoTotalICMSST, setCampoTotalICMSST] =useState(0);    
    const [campoTotalPedido, setCampoTotalPedido] = useState(0);
    const [campoBaseICMS, setCampoBaseICMS] = useState(0)
    const [campoAliquotaICMS, setCampoAliquotaICMS] = useState(0)
    const [campoValorICMS, setCampoValorICMS] = useState(0)
    const [campoBaseIPI, setCampoBaseIPI] = useState(0)
    const [campoAliquotaIPI, setCampoAliquotaIPI] = useState(0)
    const [campoValorIPI, setCampoValorIPI] = useState(0)
    const [campoBasePIS, setCampoBasePIS] = useState(0)
    const [campoAliquotaPIS, setCampoAliquotaPIS] = useState(0)
    const [campoValorPIS, setCampoValorPIS] = useState(0)
    const [campoBaseCOFINS, setCampoBaseCOFINS] = useState(0)
    const [campoAliquotaCOFINS, setCampoAliquotaCOFINS] = useState(0)
    const [campoValorCOFINS, setCampoValorCOFINS] = useState(0)
    const [campoBaseISS, setCampoBaseISS] = useState(0)
    const [campoAliquotaISS, setCampoAliquotaISS] = useState(0)
    const [campoValorISS, setCampoValorISS] = useState(0)
    const [campoBaseIRRF, setCampoBaseIRRF] = useState(0)
    const [campoAliquotaIRRF, setCampoAliquotaIRRF] = useState(0)
    const [campoValorIRRF, setCampoValorIRRF] = useState(0)
    const [campoBaseINSS, setCampoBaseINSS] = useState(0)
    const [campoAliquotaINSS, setCampoAliquotaINSS] = useState(0)
    const [campoValorINSS, setCampoValorINSS] = useState(0)
    const [campoBaseCSLL, setCampoBaseCSLL] = useState(0)
    const [campoAliquotaCSLL, setCampoAliquotaCSLL] = useState(0)
    const [campoValorCSLL, setCampoValorCSLL] = useState(0)
    const [campoBaseDIFAL, setCampoBaseDIFAL] = useState(0)
    const [campoAliquotaDIFAL, setCampoAliquotaDIFAL] = useState(0)
    const [campoValorDIFAL, setCampoValorDIFAL] = useState(0)
    const [campoBaseICMSST, setCampoBaseICMSST] = useState(0)
    const [campoAliquotaICMSST, setCampoAliquotaICMSST] = useState(0)
    const [campoValorICMSST, setCampoValorICMSST] = useState(0)
    
    const [isSolicitacao, setIsSolicitacao] = useState(false)
    const [tipoCentroCusto, setTipoCentroCusto] = useState();
    const [opcoesContaContabil, setOpcoesContaContabil] = useState();
    const [tipoProduto, setTipoProduto] = useState(null);
    
    const [queryProduto, setQueryProduto] = useState();
    const [queryContaContabil, setQueryContaContabil] = useState();
    const [queryCentroCusto, setQueryCentroCusto] = useState();
    const [queryCentroCustoReposicao, setQueryCentroCustoReposicao] = useState();

    const [dataItensPedido, setDataItensPedido] = useState([]);
    
    const options = [
        {
            value: '1',
            text: "Normal",
        },
        {
            value: '2',
            text: "Regularização",
        },
        {
            value: '3',
            text: "Emergencial",
        },
        {
            value: '5',
            text: "Reposição",
        },
        {
            value: '6',
            text: "Compra Direta",
        }
    ];

    var dataSolicitacaoCompra = []

    const loadPedidoCompra = async() => {
        
        if ( idPedidoCompra ) {
            let consultaDefault = PedidoItens.consulta;
        
            consultaDefault += "AND C7_FILIAL = FILIAL(SC7) ";
            consultaDefault += "AND C7_NUM = '" + idPedidoCompra + "'";
            consultaDefault += "ORDER BY C7_ITEM ";

            setCarregar(true);
            var retConsulta = await ConsultaTotvs( consultaDefault, PedidoItens.tabelas, empresaFilialCompras );

            if (empresaFilialDestino){
                setEmpresaFilialSelect(empresaFilialDestino) 
            }
            
            if (retConsulta.data){
                let aItens = []
                let valorFrete = 0
                retConsulta.data.map( (item, index) => {
                    const prioridadeOption = options.filter( (option) => option.value === (item.C7_XFLUXSC.trim() || "1"))
                    const tipoFreteOption = item.C7_TPFRETE === 'C' ? 'CIF' : item.C7_TPFRETE === 'F' ? 'FOB' : ''

                    const cFilial = item.C7_FILIAL                    
                    const Prioridade = {value: (item.C7_XFLUXSC.trim() || '1'), text: prioridadeOption[0].text }
                    const TipoCompra = {value: item.C7_TIPCOM, label: item.C7_TIPCOM + " - " + item.DHK_DESCR, origem: { DHK_XPRDIN: item.DHK_XPRDIN, DHK_XPRDFN: item.DHK_XPRDFN, DHK_XDSLA: item.DHK_XDSLA, DHK_XGRPRD: item.DHK_XGRPRD } }
                    const dataEmissao = converteDataProtheus(item.C7_EMISSAO);
                    const dataEntrega = converteDataProtheus(item.C7_DATPRF);
                    const cAnexoPC = item.C7_XANXPC.trim() || '[]'; //Campo Tabela Sistema
                    const cAnexoItem = item.C7_XANEXO.trim() || '[]'; //Campo Tabela Sistema

                    const Produto = {value: item.C7_PRODUTO, label: item.C7_PRODUTO + ' - ' + item.DESCRI, descricaoBD: item.C7_DESCRI}
                    const Armazem = {value: item.C7_LOCAL, label: item.C7_LOCAL + ' - ' + item.NNR_DESCRI}
                    const ContaContabil = {value: item.C7_CONTA, label: item.C7_CONTA + ' - ' + item.CT1_DESC01}
                    const CentroCusto = {value: item.C7_CC, label: item.C7_CC + ' - ' + item.CTT_DESC01}
                    const CentroCustoReposicao = {value: item.C7_CCR, label: item.C7_CCR + ' - ' + item.CC_REP}
                    
                    const Fornecedor = {value: item.C7_FORNECE + '' + item.C7_LOJA, label: item.C7_FORNECE + '/' + item.C7_LOJA + ' - ' + item.A2_NOME.trim() + '(' + item.A2_CGC.trim() + ')'}
                    const Comprador = {value: item.Y1_USER, label: item.C7_COMPRA + ' - ' + item.Y1_NOME}
                    const CondicaoPagamento = {value: item.C7_COND, label: item.C7_COND + ' - ' + item.E4_DESCRI}
                    const EnviaEmail = {value: item.C7_XENVTET === 'N' ? 'N' : ' ', text: item.C7_XENVTET === 'N' ? 'Não Enviar' : 'Enviar' }
                    const Moeda = {value: item.C7_MOEDA, label: item.C7_MOEDA + ' - ' + item.DSC_MOEDA}
                    const TipoFrete = {value: item.C7_TPFRETE, text: tipoFreteOption}

                    const tipoServicos = window._env_?.REACT_APP_TIPOS_DE_SERVICO
                    const isServico = tipoServicos.includes(item.B1_TIPO)
                    const contabil = [
                        { finalidade: 'Produto',                                        operacional: item.B1_XCONTA,     corporativo: item.B1_CONTA  },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_APLICACAO,       operacional: item.BM_XCTAVLO,   corporativo: item.BM_XCTAVLC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_CONSUMO,         operacional: item.BM_XCTCONO,   corporativo: item.BM_XCTCONC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_LOCACOES,        operacional: item.BM_XCTLOCO,   corporativo: item.BM_XCTLOCC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_SERVICOS,        operacional: item.BM_XCTSERO,   corporativo: item.BM_XCTSERC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_EPI,             operacional: item.BM_XCTEPIO,   corporativo: item.BM_XCTEPIC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_REVENDA,         operacional: item.BM_XCTREVO,   corporativo: item.BM_XCTREVC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_ATIVO,           operacional: item.BM_XCTATVO,   corporativo: item.BM_XCTATVC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_BRINDE,          operacional: item.BM_XCTBRNO,   corporativo: item.BM_XCTBRNC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_EXTRAVIO,        operacional: item.BM_XCTIEXO,   corporativo: item.BM_XCTIEXC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_SUBSTITUICAO,    operacional: item.BM_XCTISBO,   corporativo: item.BM_XCTISBC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_MANUTENCAO,      operacional: item.BM_XCTIMNO,   corporativo: item.BM_XCTIMNC }
                    ]

                    if ( index === 0 ){
                        if (!empresaFilialDestino){
                            setEmpresaFilialSelect("01"+cFilial) 
                        }
                        
                        setCampoNumero(item.C7_NUM)
                        setCampoFornecedor(Fornecedor)
                        setCampoDataEmissao(dataEmissao);
                        setCampoDataNecessidade(dataEntrega);
                        setCampoComprador(Comprador)
                        setCampoTipoCompra(TipoCompra);
                        setCampoPrioridade(Prioridade);
                        setCampoCondicaoPagamento(CondicaoPagamento)
                        setCampoEnviaEmail(EnviaEmail)
                        setCampoMoeda(Moeda)
                        setCampoTipoFrete(TipoFrete)
                        setCampoDesconto(formatarMoeda2(parseFloat(item.C7_DESC1),4))
                        setCampoJustificativaComprador(item.C7_JUSTIF)
                        setCampoObservacaoFornecedor(item.C7_OBSFOR)
                        setCampoAnexos(JSON.parse(cAnexoPC))                    
                    }
                    
                    if (parseFloat(item.C7_FRETE) > 0){
                        valorFrete = parseFloat(item.C7_FRETE)
                    }else{
                        valorFrete += parseFloat(item.C7_VALFRE)
                    }    

                    setCampoValorFrete(formatarMoeda2(valorFrete,2))
                    
                    aItens.push({ 
                        item: item.C7_ITEM,
                        produto: Produto,
                        unidadeMedida: item.C7_UM,
                        descricaoComplementar: item.C7_OBS,
                        campoArmazem: Armazem,
                        campoContaContabil: ContaContabil,
                        campoCentroCusto: CentroCusto,
                        campoCentroCustoReposicao: CentroCustoReposicao,
                        enderecoEntrega: item.C7_XENDENT,
                        quantidade: formatarMoeda2(parseFloat(item.C7_QUANT),4),
                        valorUnitario: formatarMoeda2(parseFloat(item.C7_PRECO),4),
                        valorTotal: formatarMoeda2(parseFloat(item.C7_TOTAL),2),
                        certificado: item.C7_XCA,
                        numeroNF: item.C7_XNF,
                        icms:   { IMPOSTO: 'ICMS',      BASE: formatarMoeda2(parseFloat(item.C7_BASEICM)),  ALIQUOTA: formatarMoeda2(parseFloat(item.C7_PICM)), VALOR: formatarMoeda2(parseFloat(item.C7_VALICM)) },
                        ipi:    { IMPOSTO: 'IPI',       BASE: formatarMoeda2(parseFloat(item.C7_BASEIPI)),  ALIQUOTA: formatarMoeda2(parseFloat(item.C7_IPI)), VALOR: formatarMoeda2(parseFloat(item.C7_VALIPI)) },
                        pis:    { IMPOSTO: 'PIS',       BASE: formatarMoeda2(parseFloat(item.C7_BASIMP6)),  ALIQUOTA: formatarMoeda2(parseFloat(item.C7_XALIMP6)), VALOR: formatarMoeda2(parseFloat(item.C7_VALIMP6)) },
                        cofins: { IMPOSTO: 'COFINS',    BASE: formatarMoeda2(parseFloat(item.C7_BASIMP5)),  ALIQUOTA: formatarMoeda2(parseFloat(item.C7_XALIMP5)), VALOR: formatarMoeda2(parseFloat(item.C7_VALIMP5)) },
                        iss:    { IMPOSTO: 'ISS',       BASE: formatarMoeda2(parseFloat(item.C7_BASEISS)),  ALIQUOTA: formatarMoeda2(parseFloat(item.C7_ALIQISS)), VALOR: formatarMoeda2(parseFloat(item.C7_VALISS)) },
                        irrf:   { IMPOSTO: 'IRRF',      BASE: formatarMoeda2(parseFloat(item.C7_BASEIR)),   ALIQUOTA: formatarMoeda2(parseFloat(item.C7_ALIQIR)), VALOR: formatarMoeda2(parseFloat(item.C7_VALIR)) },
                        inss:   { IMPOSTO: 'INSS',      BASE: formatarMoeda2(parseFloat(item.C7_BASEINS)),  ALIQUOTA: formatarMoeda2(parseFloat(item.C7_ALIQINS)), VALOR: formatarMoeda2(parseFloat(item.C7_VALINS)) },
                        csll:   { IMPOSTO: 'CSLL',      BASE: formatarMoeda2(parseFloat(item.C7_BASECSL)),  ALIQUOTA: formatarMoeda2(parseFloat(item.C7_ALQCSL)), VALOR: formatarMoeda2(parseFloat(item.C7_VALCSL)) },
                        difal:  { IMPOSTO: 'DIFAL',     BASE: formatarMoeda2(parseFloat(item.C7_XBSDIF)),   ALIQUOTA: formatarMoeda2(parseFloat(item.C7_XALDIF)), VALOR: formatarMoeda2(parseFloat(item.C7_ICMCOMP)) },
                        icmsST: { IMPOSTO: 'ICMSST',    BASE: formatarMoeda2(parseFloat(item.C7_BASESOL)),  ALIQUOTA: formatarMoeda2(parseFloat(item.C7_XALSOL)), VALOR: formatarMoeda2(parseFloat(item.C7_ICMSRET)) },
                        percentualDesconto: 0,
                        desconto: 0,
                        solicitacao: item.C7_NUMSC,
                        itemSolicitacao: item.C7_ITEMSC,
                        anexoItem: cAnexoItem,
                        opcoesContaContabil: contabil,
                        tipoProduto: isServico,
                        tipoCentroCusto: item.CTT_XTIPO.trim(),
                        deletado: false
                    })
                });

                setDataItensPedido(aItens);
            }

            setCarregar(false);
        }
    }

    useEffect( () => {
        const fetchData = async() => {
            await loadPedidoCompra()
        }

        fetchData()
    }, []);

    const columnsItensPedido = [
        {
            Header: 'Produto',
            accessor: 'produto.label',
        },
        {
            Header: 'U. M.',
            accessor: 'unidadeMedida',
            render: handleUMedidaQtd
        },
        {
            Header: 'Qtde.',
            accessor: 'quantidade',
            render: handleValorUnitarioCard
        },
        {
            Header: 'Valor Total',
            accessor: 'valorTotal',
            render: handleValorTotalPCCard
        },
        {
            Header: 'Centro de Custo',
            accessor: 'campoCentroCusto.label',
            render: handleCentroCustoLabel
        },
        {
            Header: 'Solic. Compra',
            accessor: 'solicitacao',
            render: handleSolicCompra
        },
    ]

    const columnsAditional = [
        {
            Header: 'Conta Contabil',
            accessor: 'campoContaContabil.label',
        },
        {
            Header: 'Descrição Complementar',
            accessor: 'descricaoComplementar'
        },
        {
            Header: 'Anexos Item',
            accessor: 'anexoItem',
            render: handleAnexos
        },
    ]

    const handleAddFilesPC = async(acceptedFiles, fileRejections, event) => {
        const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];
        const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

        if (!isValidFileType) {
            toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC ou arquivos de texto.');
            return;
        }

        const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
        
        if (event){
            event.persist()
            event.preventDefault()
        }

        if (retUpload.error === "00") {
            const newFiles = retUpload.data.map(file => file);
            const filesUpload = [...campoAnexos, ...newFiles]
            setCampoAnexos(filesUpload)

            return filesUpload;
        }
    }

    const handleDelFilesPC = (fileDelete) => {
        const updatedFiles = [...campoAnexos];
        updatedFiles.splice(fileDelete, 1);

        setCampoAnexos(updatedFiles)
        return updatedFiles;
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)
    }

    const handleProduto = (e) => {
        const tipoServicos = window._env_?.REACT_APP_TIPOS_DE_SERVICO

        if (e){
            let contabil = [
                { finalidade: 'Produto',                                        operacional: e.origem.B1_XCONTA,     corporativo: e.origem.B1_CONTA  },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_APLICACAO,       operacional: e.origem.BM_XCTAVLO,   corporativo: e.origem.BM_XCTAVLC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_CONSUMO,         operacional: e.origem.BM_XCTCONO,   corporativo: e.origem.BM_XCTCONC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_LOCACOES,        operacional: e.origem.BM_XCTLOCO,   corporativo: e.origem.BM_XCTLOCC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_SERVICOS,        operacional: e.origem.BM_XCTSERO,   corporativo: e.origem.BM_XCTSERC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_EPI,             operacional: e.origem.BM_XCTEPIO,   corporativo: e.origem.BM_XCTEPIC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_REVENDA,         operacional: e.origem.BM_XCTREVO,   corporativo: e.origem.BM_XCTREVC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_ATIVO,           operacional: e.origem.BM_XCTATVO,   corporativo: e.origem.BM_XCTATVC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_BRINDE,          operacional: e.origem.BM_XCTBRNO,   corporativo: e.origem.BM_XCTBRNC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_EXTRAVIO,        operacional: e.origem.BM_XCTIEXO,   corporativo: e.origem.BM_XCTIEXC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_SUBSTITUICAO,    operacional: e.origem.BM_XCTISBO,   corporativo: e.origem.BM_XCTISBC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_MANUTENCAO,      operacional: e.origem.BM_XCTIMNO,   corporativo: e.origem.BM_XCTIMNC }
            ]
            
            const isServico = tipoServicos.includes((e.origem ? e.origem.B1_TIPO: ''))
            setCampoUnidade((e.origem ? e.origem.B1_UM : ''))
            setCampoProduto({ value: e.value, label: e.label, descricaoBD: e.origem.B1_DESC } )
            setOpcoesContaContabil(contabil);
            setTipoProduto(isServico)
            
            return
        }
        
        setCampoProduto();
        setCampoUnidade("");
        setTipoProduto(null)
        setOpcoesContaContabil([]);
    }

    const handleBlurImposto = async() => {
        if (campoProduto?.value && parseLocaleNumber(campoValorTotal) > 0){
            setCarregar(true);
            const jsonEnvio = {
                FORNECEDOR: campoFornecedor.value.substr(0,6),
                LOJA: campoFornecedor.value.substr(6,4),
                PRODUTO: campoProduto.value,
                QUANTIDADE: parseLocaleNumber(campoQuantidade),
                PRECO: parseLocaleNumber(campoValorUnitario),
                TOTAL: parseLocaleNumber(campoValorTotal),
                FINALIDADE: campoTipoCompra.value
            }
            
            const retornoCalculaImposto = await ConsumoTOTVS_POST('CALCULAIMPOSTO', jsonEnvio, empresaFilial)
            const retImposto = retornoCalculaImposto?.data || [];

            const icms = retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'ICMS')[0]
            const ipi = retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'IPI')[0]
            const pis = retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'PIS')[0]
            const cofins = retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'COFINS')[0]
            const iss = retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'ISS')[0]
            const irrf = retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'IRRF')[0]
            const inss = retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'INSS')[0]
            const csll = retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'CSLL')[0]
            const difal = retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'DIFAL')[0]
            const icmsST = retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'ICMSST')[0]

            setCampoBaseICMS( formatarMoeda2(parseFloat( icms?.BASE || 0),2) );
            setCampoAliquotaICMS( formatarMoeda2(parseFloat( icms?.ALIQUOTA || 0),2) );
            setCampoValorICMS( formatarMoeda2(parseFloat( icms?.VALOR || 0),2) );
            setCampoBaseIPI( formatarMoeda2(parseFloat( ipi?.BASE || 0),2) );
            setCampoAliquotaIPI( formatarMoeda2(parseFloat( ipi?.ALIQUOTA || 0),2) );
            setCampoValorIPI( formatarMoeda2(parseFloat( ipi?.VALOR || 0),2) );
            setCampoBasePIS( formatarMoeda2(parseFloat( pis?.BASE || 0),2) );
            setCampoAliquotaPIS( formatarMoeda2(parseFloat( pis?.ALIQUOTA || 0),2) );
            setCampoValorPIS( formatarMoeda2(parseFloat( pis?.VALOR || 0),2) );
            setCampoBaseCOFINS( formatarMoeda2(parseFloat( cofins?.BASE || 0),2) );
            setCampoAliquotaCOFINS( formatarMoeda2(parseFloat( cofins?.ALIQUOTA || 0),2) );
            setCampoValorCOFINS( formatarMoeda2(parseFloat( cofins?.VALOR || 0),2) );
            setCampoBaseISS( formatarMoeda2(parseFloat( iss?.BASE || 0),2) );
            setCampoAliquotaISS( formatarMoeda2(parseFloat( iss?.ALIQUOTA || 0),2) );
            setCampoValorISS( formatarMoeda2(parseFloat( iss?.VALOR || 0),2) );
            setCampoBaseIRRF( formatarMoeda2(parseFloat( irrf?.BASE || 0),2) );
            setCampoAliquotaIRRF( formatarMoeda2(parseFloat( irrf?.ALIQUOTA || 0),2) );
            setCampoValorIRRF( formatarMoeda2(parseFloat( irrf?.VALOR || 0),2) );
            setCampoBaseINSS( formatarMoeda2(parseFloat( inss?.BASE || 0),2) );
            setCampoAliquotaINSS( formatarMoeda2(parseFloat( inss?.ALIQUOTA || 0),2) );
            setCampoValorINSS( formatarMoeda2(parseFloat( inss?.VALOR || 0),2) );
            setCampoBaseCSLL( formatarMoeda2(parseFloat( csll?.BASE || 0),2) );
            setCampoAliquotaCSLL( formatarMoeda2(parseFloat( csll?.ALIQUOTA || 0),2) );
            setCampoValorCSLL( formatarMoeda2(parseFloat( csll?.VALOR || 0),2) );
            setCampoBaseDIFAL( formatarMoeda2(parseFloat( difal?.BASE || 0),2) );
            setCampoAliquotaDIFAL( formatarMoeda2(parseFloat( difal?.ALIQUOTA || 0),2) );
            setCampoValorDIFAL( formatarMoeda2(parseFloat( difal?.VALOR || 0),2) );
            setCampoBaseICMSST( formatarMoeda2(parseFloat( icmsST?.BASE || 0),2) );
            setCampoAliquotaICMSST( formatarMoeda2(parseFloat( icmsST?.ALIQUOTA || 0),2) );
            setCampoValorICMSST( formatarMoeda2(parseFloat( icmsST?.VALOR || 0),2) );
            setCarregar(false);
        }
    }

    const handleCampoQuantidade = (e, valor) => {
        const inputValue = valor;
        
        if (/^(?:\d{1,3}(?:\.\d{3})*)(?:\,\d{0,4})?$/.test(inputValue) || inputValue === '') {
            const valorTotal = parseLocaleNumber(inputValue) * parseLocaleNumber(campoValorUnitario)
    
            setCampoQuantidade(inputValue)
            setCampoValorTotal(formatarMoeda2(valorTotal,2))
        }
    }

    const handleCampoValorUnitario = (e, valor) => {
        const inputValue = valor;
        
        // Validate if the input is a valid number with up to 6 decimals
        if (/^(?:\d{1,3}(?:\.\d{3})*)(?:\,\d{0,4})?$/.test(inputValue) || inputValue === '') {
            const valorTotal = parseLocaleNumber(inputValue) * parseLocaleNumber(campoQuantidade)

            setCampoValorUnitario(inputValue);
            setCampoValorTotal(formatarMoeda2(valorTotal,2));
        }
    }

    const retornaConsultaCentroCusto = (cCentroCusto) =>{
        let consultaCentroCustoFormatada = !cCentroCusto ? "" : ConsultaCentroCusto.consulta + 
            " WHERE CTT_FILIAL = FILIAL(CTT) " + 
            " AND CTT.D_E_L_E_T_ <> '*'" +
            " AND CTT_CLASSE = '2'" +
            " AND CTT_BLOQ = '2'" +
            " AND CTT_CUSTO = '" + cCentroCusto + "'"

        return consultaCentroCustoFormatada
    }

    const handleArmazem = (e) => {
        let cConsulta = retornaConsultaCentroCusto(e.origem.NNR_XCC)
        setQueryCentroCusto(cConsulta)
        setQueryCentroCustoReposicao(cConsulta.replace('CTT_CUSTO =', 'CTT_CUSTO !='))
        setTipoCentroCusto('')

        //Sempre que altera o Armazem, deve limpar o Centro de Custo e a Conta Contabil
        setCampoArmazem({ value: e.value, label: e.label })
        setCampoCentroCusto({value: '', label: 'Selecione o Centro de Custo'})
        setCampoCentroCustoReposicao({value: '', label: 'Selecione o Centro de Custo de Reposição'})
        setCampoContaContabil({value: '', label: 'Selecione a Conta Contabil'})
    }

    const handleCampoCentroCusto = (e) => {
        setCampoEnderecoEntrega(e.origem.CTT_CEP + ' - ' + e.origem.CTT_ENDER + ', ' + e.origem.CTT_BAIRRO + ' - ' +  e.origem.CTT_MUNIC + '/' + e.origem.CTT_ESTADO)
        setCampoCentroCusto({ value: e.value, label: e.label })
        setTipoCentroCusto(e.origem.CTT_XTIPO.trim())
    }

    const handleCampoCentroCustoReposicao = (e) => {
        setCampoEnderecoEntrega(e.origem.CTT_CEP + ' - ' + e.origem.CTT_ENDER + ', ' + e.origem.CTT_BAIRRO + ' - ' +  e.origem.CTT_MUNIC + '/' + e.origem.CTT_ESTADO)
        setCampoCentroCustoReposicao({ value: e.value, label: e.label })
    }

    useEffect( () => {
        if (campoTipoCompra && tipoCentroCusto && opcoesContaContabil.length > 0){
            const contaProduto = (tipoCentroCusto === "2" ? opcoesContaContabil[0].operacional : opcoesContaContabil[0].corporativo).trim()
                        
            if (contaProduto){
                let cConsulta = ConsultaContaContabil.consulta + 
                                " WHERE CT1_FILIAL = FILIAL(CT1) AND D_E_L_E_T_ != '*' " + 
                                " AND CT1_CONTA = '" + (contaProduto) + "'"
                
                setQueryContaContabil(cConsulta)
            }else{
                let opcaoContaProduto = opcoesContaContabil.filter( (item) => item.finalidade === campoTipoCompra.value )

                if (opcaoContaProduto && opcaoContaProduto.length > 0){
                    let contaProduto = ( tipoCentroCusto === "2" ? opcaoContaProduto[0].operacional : opcaoContaProduto[0].corporativo).trim()
                    let cConsulta = ConsultaContaContabil.consulta + 
                                    " WHERE CT1_FILIAL = FILIAL(CT1) AND D_E_L_E_T_ != '*' " + 
                                    " AND CT1_CONTA = '" + (contaProduto) + "'"
                    
                    setQueryContaContabil(cConsulta)
                }else if(!campoContaContabil?.value){
                    let cConsulta = ConsultaContaContabil.consulta + 
                                    " WHERE CT1_FILIAL = FILIAL(CT1) " +
                                    " AND D_E_L_E_T_ != '*' " +
                                    " AND CT1_CONTA = '' "
                    setCampoContaContabil({value: '', label: 'Selecione a Conta Contabil'})
                    setQueryContaContabil(cConsulta)
                }
            }
        }
    }, [campoTipoCompra, opcoesContaContabil, campoArmazem, tipoCentroCusto])

    useEffect( () => {
        if (campoTipoCompra?.origem){
            const item = campoTipoCompra.origem
            if (item.DHK_XPRDIN || item.DHK_XPRDFN || item.DHK_XGRPRD){
                let cQueryProduto = ''
                
                // if (item.DHK_XPRDIN){
                //     cQueryProduto += " AND B1_COD >= '" + item.DHK_XPRDIN + "' "
                // }
                
                // if (item.DHK_XPRDFN){
                //     cQueryProduto += " AND B1_COD <= '" + item.DHK_XPRDFN + "' "
                // }

                switch (campoTipoCompra.value) {
                    case window._env_?.REACT_APP_FINALIDADE_APLICACAO:
                        cQueryProduto += " AND ( ( BM_XCTAVLO != '' AND BM_XCTAVLC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_CONSUMO:
                        cQueryProduto += " AND ( ( BM_XCTCONO != '' AND BM_XCTCONC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_LOCACOES:
                        cQueryProduto += " AND ( ( BM_XCTLOCO != '' AND BM_XCTLOCC != '' ) "                    
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_SERVICOS:
                        cQueryProduto += " AND ( ( BM_XCTSERO != '' AND BM_XCTSERC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_EPI:
                        cQueryProduto += " AND ( ( BM_XCTEPIO != '' AND BM_XCTEPIC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_REVENDA:
                        cQueryProduto += " AND ( ( BM_XCTREVO != '' AND BM_XCTREVC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_ATIVO:
                        cQueryProduto += " AND ( ( BM_XCTATVO != '' AND BM_XCTATVC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_BRINDE:
                        cQueryProduto += " AND ( ( BM_XCTBRNO != '' AND BM_XCTBRNC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_EXTRAVIO:
                        cQueryProduto += " AND ( ( BM_XCTIEXO != '' AND BM_XCTIEXC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_SUBSTITUICAO:
                        cQueryProduto += " AND ( ( BM_XCTISBO != '' AND BM_XCTISBC != '' ) "                    
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_MANUTENCAO:
                        cQueryProduto += " AND ( ( BM_XCTIMNO != '' AND BM_XCTIMNC != '' ) "
                        break;
                    default:
                        cQueryProduto += " AND ( ( 1 = 1  ) "
                        break;
                }
                
                if (item.DHK_XGRPRD.trim().slice(0,-1)){
                    cQueryProduto += " OR B1_GRUPO IN ('" + item.DHK_XGRPRD.trim().slice(0,-1).replaceAll(';', "','") + "')  "
                }
                
                cQueryProduto += " ) "
        
                setQueryProduto(cQueryProduto)
            }

            setDiasSLA(parseInt(item.DHK_XDSLA))
        }    
    }, [campoTipoCompra])

    useEffect( () => {
        if (campoPrioridade.value){
            let diasSLAData = diasSLA
            let data = currentDate; // Data atual

            if (campoPrioridade.value === '3'){
                setDiasSLA(0)
                diasSLAData = 0;
            }

            if (diasSLAData > 0){
                data.setDate(data.getDate() + diasSLAData);
            }
            
            if (!campoDataNecessidade){
                setCampoDataNecessidade(format(data, 'yyyy-MM-dd'))
            }
        }
    }, [campoPrioridade])

    const handleAddFiles = async(acceptedFiles, fileRejections, event) => {
        const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];
        const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

        if (!isValidFileType) {
            toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC ou arquivos de texto.');
            return;
        }

        const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
        
        if (event){
            event.persist()
            event.preventDefault()
        }

        if (retUpload.error === "00") {
            const newFiles = retUpload.data.map(file => file);
            const filesUpload = [...campoAnexosItem, ...newFiles]
            setCampoAnexosItem(filesUpload)

            return filesUpload;
        }
    }

    const handleDelFiles = (fileDelete) => {
        const updatedFiles = [...campoAnexosItem];
        updatedFiles.splice(fileDelete, 1);
        
        setCampoAnexosItem(updatedFiles)
        return updatedFiles;
    }

    const handleNewItem = () => {
        setCampoItem('0000')
        setIsSolicitacao(false)
        setHabilitaItem(true)
    }
    
    const handleConfirmNewItem = () => {
        if (!campoContaContabil?.value.trim()){
            toast.warning('Conta Contábil é obrigatória.');
            return;
        }

        // Se For Item já Cadastrado vai ter o valor para o campo Item
        if (campoItem !== '0000'){
            const id = campoItem
            
            setDataItensPedido((prevData) => {
                return prevData.map((item) => {
                    if (item.item === id){
                        return { ...item, 
                                produto: campoProduto,
                                unidadeMedida: campoUnidade,
                                descricaoComplementar: campoDescricaoComplementar,
                                campoArmazem,
                                campoContaContabil,
                                campoCentroCusto,
                                campoCentroCustoReposicao,
                                enderecoEntrega: campoEnderecoEntrega,
                                quantidade: campoQuantidade,
                                valorUnitario: campoValorUnitario,
                                valorTotal: campoValorTotal,
                                certificado: campoCA,
                                numeroNF: campoNumeroNF,
                                icms: { IMPOSTO: 'ICMS', BASE: campoBaseICMS, ALIQUOTA: campoAliquotaICMS, VALOR: campoValorICMS },
                                ipi: { IMPOSTO: 'IPI', BASE: campoBaseIPI, ALIQUOTA: campoAliquotaIPI, VALOR: campoValorIPI },
                                pis: { IMPOSTO: 'PIS', BASE: campoBasePIS, ALIQUOTA: campoAliquotaPIS, VALOR: campoValorPIS },
                                cofins: { IMPOSTO: 'COFINS', BASE: campoBaseCOFINS, ALIQUOTA: campoAliquotaCOFINS, VALOR: campoValorCOFINS },
                                iss: { IMPOSTO: 'ISS', BASE: campoBaseISS, ALIQUOTA: campoAliquotaISS, VALOR: campoValorISS },
                                irrf: { IMPOSTO: 'IRRF', BASE: campoBaseIRRF, ALIQUOTA: campoAliquotaIRRF, VALOR: campoValorIRRF },
                                inss: { IMPOSTO: 'INSS', BASE: campoBaseINSS, ALIQUOTA: campoAliquotaINSS, VALOR: campoValorINSS },
                                csll: { IMPOSTO: 'CSLL', BASE: campoBaseCSLL, ALIQUOTA: campoAliquotaCSLL, VALOR: campoValorCSLL },
                                difal: { IMPOSTO: 'DIFAL', BASE: campoBaseDIFAL, ALIQUOTA: campoAliquotaDIFAL, VALOR: campoValorDIFAL },
                                icmsST: { IMPOSTO: 'ICMSST', BASE: campoBaseICMSST, ALIQUOTA: campoAliquotaICMSST, VALOR: campoValorICMSST },
                                percentualDesconto: 0,
                                desconto: 0,
                                solicitacao: item.solicitacao,
                                itemSolicitacao: item.itemSolicitacao,
                                anexoItem: JSON.stringify(campoAnexosItem) || '[]',
                                opcoesContaContabil,
                                tipoProduto,
                                tipoCentroCusto,
                                deletado: false
                            };
                    }else{
                        return item;
                    } 
                })
            });

            setCampoItem('')
        }else{
            const dataLastItem = dataItensPedido.findLast( (item) => item.item )
            const lastItem = parseFloat( dataLastItem ? dataLastItem.item : '0')
            const item = String(lastItem + 1)

            setDataItensPedido(
                (prevData) => [...prevData, 
                    {   numero: "", 
                        item: item.padStart(4, '0'),
                        produto: campoProduto,
                        unidadeMedida: campoUnidade,
                        descricaoComplementar: campoDescricaoComplementar,
                        campoArmazem,
                        campoContaContabil,
                        campoCentroCusto,
                        campoCentroCustoReposicao,
                        enderecoEntrega: campoEnderecoEntrega,
                        quantidade: campoQuantidade,
                        valorUnitario: campoValorUnitario,
                        valorTotal: campoValorTotal,
                        certificado: campoCA,
                        numeroNF: campoNumeroNF,
                        icms: { IMPOSTO: 'ICMS', BASE: campoBaseICMS, ALIQUOTA: campoAliquotaICMS, VALOR: campoValorICMS },
                        ipi: { IMPOSTO: 'IPI', BASE: campoBaseIPI, ALIQUOTA: campoAliquotaIPI, VALOR: campoValorIPI },
                        pis: { IMPOSTO: 'PIS', BASE: campoBasePIS, ALIQUOTA: campoAliquotaPIS, VALOR: campoValorPIS },
                        cofins: { IMPOSTO: 'COFINS', BASE: campoBaseCOFINS, ALIQUOTA: campoAliquotaCOFINS, VALOR: campoValorCOFINS },
                        iss: { IMPOSTO: 'ISS', BASE: campoBaseISS, ALIQUOTA: campoAliquotaISS, VALOR: campoValorISS },
                        irrf: { IMPOSTO: 'IRRF', BASE: campoBaseIRRF, ALIQUOTA: campoAliquotaIRRF, VALOR: campoValorIRRF },
                        inss: { IMPOSTO: 'INSS', BASE: campoBaseINSS, ALIQUOTA: campoAliquotaINSS, VALOR: campoValorINSS },
                        csll: { IMPOSTO: 'CSLL', BASE: campoBaseCSLL, ALIQUOTA: campoAliquotaCSLL, VALOR: campoValorCSLL },
                        difal: { IMPOSTO: 'DIFAL', BASE: campoBaseDIFAL, ALIQUOTA: campoAliquotaDIFAL, VALOR: campoValorDIFAL },
                        icmsST: { IMPOSTO: 'ICMSST', BASE: campoBaseICMSST, ALIQUOTA: campoAliquotaICMSST, VALOR: campoValorICMSST },
                        percentualDesconto: 0,
                        desconto: 0,
                        solicitacao: '',
                        itemSolicitacao: '',
                        anexoItem: JSON.stringify(campoAnexosItem) || '[]',
                        opcoesContaContabil,
                        tipoProduto,
                        tipoCentroCusto,
                        deletado: false
                    },
                ]
            );
        }

        handleFecharItem()
    }

    const handleFecharItem = () => {
        setQueryContaContabil("")
        setQueryCentroCusto("")
        setQueryCentroCustoReposicao("")
        setTipoCentroCusto("")
        setOpcoesContaContabil([])
        setTipoProduto(null)

        //Clear Campos
        setCampoItem('')
        setCampoProduto();
        setCampoUnidade('');
        setCampoDescricaoComplementar('');
        setCampoQuantidade(formatarMoeda2(0,4));
        setCampoValorUnitario(formatarMoeda2(0,4));
        setCampoValorTotal(formatarMoeda2(0,2));
        setCampoArmazem({value: '', label: 'Selecione o Armazém'});
        setCampoContaContabil({value: '', label: 'Selecione a Conta Contabil'});
        setCampoCentroCusto({value: '', label: 'Selecione o Centro de Custo'});
        setCampoCentroCustoReposicao({value: '', label: 'Selecione o Centro de Custo de Reposição'});
        setCampoEnderecoEntrega('');
        setCampoAnexosItem([]);
        setCampoBaseICMS(formatarMoeda2(0,2));
        setCampoAliquotaICMS(formatarMoeda2(0,2));
        setCampoValorICMS(formatarMoeda2(0,2));
        setCampoBaseIPI(formatarMoeda2(0,2));
        setCampoAliquotaIPI(formatarMoeda2(0,2));
        setCampoValorIPI(formatarMoeda2(0,2));
        setCampoBasePIS(formatarMoeda2(0,2));
        setCampoAliquotaPIS(formatarMoeda2(0,2));
        setCampoValorPIS(formatarMoeda2(0,2));
        setCampoBaseCOFINS(formatarMoeda2(0,2));
        setCampoAliquotaCOFINS(formatarMoeda2(0,2));
        setCampoValorCOFINS(formatarMoeda2(0,2));
        setCampoBaseISS(formatarMoeda2(0,2));
        setCampoAliquotaISS(formatarMoeda2(0,2));
        setCampoValorISS(formatarMoeda2(0,2));
        setCampoBaseIRRF(formatarMoeda2(0,2));
        setCampoAliquotaIRRF(formatarMoeda2(0,2));
        setCampoValorIRRF(formatarMoeda2(0,2));
        setCampoBaseINSS(formatarMoeda2(0,2));
        setCampoAliquotaINSS(formatarMoeda2(0,2));
        setCampoValorINSS(formatarMoeda2(0,2));
        setCampoBaseCSLL(formatarMoeda2(0,2));
        setCampoAliquotaCSLL(formatarMoeda2(0,2));
        setCampoValorCSLL(formatarMoeda2(0,2));
        setCampoBaseDIFAL(formatarMoeda2(0,2));
        setCampoAliquotaDIFAL(formatarMoeda2(0,2));
        setCampoValorDIFAL(formatarMoeda2(0,2));
        setCampoBaseICMSST(formatarMoeda2(0,2));
        setCampoAliquotaICMSST(formatarMoeda2(0,2));
        setCampoValorICMSST(formatarMoeda2(0,2));

        setHabilitaItem(false)
    }

    const calculaTotais = () => {
        if (dataItensPedido && dataItensPedido.length > 0){
            let nTotalICMS      = 0;
            let nTotalIPI       = 0;
            let nTotalPIS       = 0;
            let nTotalISS       = 0;
            let nTotalIRRF      = 0;
            let nTotalINSS      = 0;
            let nTotalCSLL      = 0;
            let nTotalDIFAL     = 0;
            let nTotalICMSST    = 0;
            let nValorDesconto  = 0;
            let nValorTotal     = 0;
            let nTotalPedido    = 0;

            dataItensPedido.forEach((item) => {
                if (item.deletado === false){
                    const nProduto = parseLocaleNumber(item.quantidade) * parseLocaleNumber(item.valorUnitario)
                    const descontoItem = parseLocaleNumber(campoDesconto) > 0 ? parseFloat((nProduto * (parseLocaleNumber(campoDesconto)/100)).toFixed(2),2) : 0;
                    const totalItem = parseLocaleNumber(item.valorTotal) - descontoItem

                    nTotalICMS      += Number(item.icms?.VALOR) || 0
                    nTotalIPI       += Number(item.ipi?.VALOR) || 0
                    nTotalPIS       += Number(item.pis?.VALOR) || 0
                    nTotalISS       += Number(item.iss?.VALOR) || 0
                    nTotalIRRF      += Number(item.irrf?.VALOR) || 0
                    nTotalINSS      += Number(item.inss?.VALOR) || 0
                    nTotalCSLL      += Number(item.csll?.VALOR) || 0
                    nTotalDIFAL     += Number(item.difal?.VALOR) || 0
                    nTotalICMSST    += Number(item.icmsst?.VALOR) || 0
                    nValorDesconto  += descontoItem
                    nValorTotal     += nProduto
                    nTotalPedido    += Number(totalItem)
                }
            })

            setCampoTotalICMS(nTotalICMS.toFixed(2));
            setCampoTotalIPI(nTotalIPI.toFixed(2));
            setCampoTotalPIS(nTotalPIS.toFixed(2));
            setCampoTotalISS(nTotalISS.toFixed(2));
            setCampoTotalIRRF(nTotalIRRF.toFixed(2));
            setCampoTotalINSS(nTotalINSS.toFixed(2));
            setCampoTotalCSLL(nTotalCSLL.toFixed(2));
            setCampoTotalDIFAL(nTotalDIFAL.toFixed(2));
            setCampoTotalICMSST(nTotalICMSST.toFixed(2));
            setCampoValorDesconto(nValorDesconto.toFixed(2));
            setCampoValorTotalProdutos(nValorTotal.toFixed(2));

            if (campoTipoFrete.value === 'F'){
                nTotalPedido += parseLocaleNumber(campoValorFrete);
            }

            setCampoTotalPedido(nTotalPedido.toFixed(2));
        }
    }

    const handleVincularItem = async() => {
        setCarregar(true);

        let cEmpresaFilial = empresaFilial.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresaFilial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL)
        let consulta = Solicitacao.consulta + " AND C1_EMISSAO >= '20241001' AND " + optionsStatusSC[1].filtroSQL
        
        //Ignorar SC que já está vinculada
        const scVinculada = dataItensPedido.map( (item) => {return item.SC + item.ItemSC}).join("','")

        consulta += " AND C1_FILIAL = '" + empresaFilial.substring(2,8) + "' "

        if (scVinculada){
            consulta += " AND C1_NUM + C1_ITEM NOT IN ('" + scVinculada + "') "
        }
        
        consulta += " AND C1_TIPCOM = '" + campoTipoCompra.value + "' "

        if (campoComprador?.value){
            consulta += " ORDER BY IIF(C1_CODCOMP = '" + campoComprador.value + "', 1, 2) ASC, NECESSIDADE ASC" //+ Data Previsao Mais proxima
        }

        const retConsulta = await ConsultaTotvsEmpresa(consulta, Solicitacao.tabelas, cEmpresaFilial)
        
        if (retConsulta.data){
            if (retConsulta.data.length > 0){
                dataSolicitacaoCompra = retConsulta.data.map( (item) => { item.Check = false; return item });
            }
        }

        setCarregar(false);
        if (dataSolicitacaoCompra.length > 0){
            SelecaoSolicitacaoCompra( DisparaBootBox, FechaSelecaoSC, dataSolicitacaoCompra, FechaBootBox);
        }
    }

    const FechaSelecaoSC = async() => {
        let scSelecionada = dataSolicitacaoCompra.filter( (item) => item.Check === true)
        const dataLastItem = dataItensPedido.length > 0
            ? dataItensPedido.reduce((maior, atual) => {
            return atual.item > maior.item ? atual : maior;
        }) : undefined;
        let lastItem = parseFloat( dataLastItem ? dataLastItem.item : '0')
        
        let newItens = await Promise.all(retornaItemComImposto(scSelecionada, lastItem));

        const newDataPC = [...dataItensPedido, ...newItens];
        //Colocar o Anexo da SC no Anexo do Pedido C1_XANEXO
        const anexosSC = newDataPC.map( (item) => {
            return JSON.parse(item.C1_XANEXO || '[]')
        }).filter( (item) => item.length > 0).flat()

        const filesUpload = [...campoAnexos, ...anexosSC]

        const unicosPorFilename = Object.values(
            filesUpload.reduce((acc, item) => {
                if (!acc[item.filename]) {
                    acc[item.filename] = item; // pega apenas o primeiro
                }
                
                return acc;
            }, {})
        );

        setCampoAnexos(unicosPorFilename);
        setDataItensPedido(newDataPC);

        FechaBootBox()
    }

    function formatarImposto(obj) {
        obj.BASE = formatarMoeda2(parseFloat(obj.BASE),2);
        obj.ALIQUOTA = formatarMoeda2(parseFloat(obj.ALIQUOTA),2);
        obj.VALOR = formatarMoeda2(parseFloat(obj.VALOR),2);

        return obj;
    }

    const retornaItemComImposto = (scSelecionada, lastItem) => {
        return scSelecionada.map( async(itemMap) => { 
            lastItem++
            const jsonEnvio = {
                FORNECEDOR: campoFornecedor.value.substr(0,6),
                LOJA: campoFornecedor.value.substr(6,4),
                PRODUTO: itemMap.C1_PRODUTO,
                QUANTIDADE: itemMap.C1_QUANT,
                PRECO: itemMap.C1_PRECO,
                TOTAL: itemMap.C1_TOTAL,
                FINALIDADE: itemMap.C1_TIPCOM
            }
            
            const tipoServicos = window._env_?.REACT_APP_TIPOS_DE_SERVICO
            const proximoItem = String(lastItem)
            const retornoCalculaImposto = await ConsumoTOTVS_POST('CALCULAIMPOSTO', jsonEnvio, empresaFilial)
            const retImposto = retornoCalculaImposto?.data || [];
            const isServico = tipoServicos.includes(itemMap.B1_TIPO)
            const contabil = [
                { finalidade: 'Produto',                                          operacional: itemMap.B1_XCONTA,     corporativo: itemMap.B1_CONTA  },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_APLICACAO,       operacional: itemMap.BM_XCTAVLO,   corporativo: itemMap.BM_XCTAVLC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_CONSUMO,         operacional: itemMap.BM_XCTCONO,   corporativo: itemMap.BM_XCTCONC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_LOCACOES,        operacional: itemMap.BM_XCTLOCO,   corporativo: itemMap.BM_XCTLOCC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_SERVICOS,        operacional: itemMap.BM_XCTSERO,   corporativo: itemMap.BM_XCTSERC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_EPI,             operacional: itemMap.BM_XCTEPIO,   corporativo: itemMap.BM_XCTEPIC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_REVENDA,         operacional: itemMap.BM_XCTREVO,   corporativo: itemMap.BM_XCTREVC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_ATIVO,           operacional: itemMap.BM_XCTATVO,   corporativo: itemMap.BM_XCTATVC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_BRINDE,          operacional: itemMap.BM_XCTBRNO,   corporativo: itemMap.BM_XCTBRNC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_EXTRAVIO,        operacional: itemMap.BM_XCTIEXO,   corporativo: itemMap.BM_XCTIEXC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_SUBSTITUICAO,    operacional: itemMap.BM_XCTISBO,   corporativo: itemMap.BM_XCTISBC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_MANUTENCAO,      operacional: itemMap.BM_XCTIMNO,   corporativo: itemMap.BM_XCTIMNC }
            ]

            
            const item = {
                item: proximoItem.padStart(4, '0'),
                produto: {value: itemMap.C1_PRODUTO, label: itemMap.C1_PRODUTO + ' - ' + itemMap.DESCRI, descricaoBD: itemMap.C1_DESCRI},
                unidadeMedida: itemMap.C1_UM,
                descricaoComplementar: itemMap.C1_OBS,
                campoArmazem: {value: itemMap.C1_LOCAL, label: itemMap.C1_LOCAL + ' - ' + itemMap.NNR_DESCRI},
                campoContaContabil: {value: itemMap.C1_CONTA, label: itemMap.C1_CONTA + ' - ' + itemMap.CT1_DESC01},
                campoCentroCusto: {value: itemMap.C1_CC, label: itemMap.C1_CC + ' - ' + itemMap.CTT_DESC01},
                campoCentroCustoReposicao: {value: itemMap.C1_XCCR, label: itemMap.C1_XCCR + ' - ' + itemMap.CC_REP},
                enderecoEntrega: itemMap.C1_XENDENT,
                quantidade: formatarMoeda2(parseFloat(itemMap.C1_QUANT, 4)),
                valorUnitario: formatarMoeda2(parseFloat(itemMap.C1_PRECO),4),
                valorTotal: formatarMoeda2(parseFloat(itemMap.C1_TOTAL),2),
                certificado: itemMap.C1_XCA,
                numeroNF: itemMap.C1_XNF,
                icms: formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'ICMS')[0]),
                ipi: formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'IPI')[0]),
                pis: formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'PIS')[0]),
                cofins: formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'COFINS')[0]),
                iss: formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'ISS')[0]),
                irrf: formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'IRRF')[0]),
                inss: formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'INSS')[0]),
                csll: formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'CSLL')[0]),
                difal: formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'DIFAL')[0]),
                icmsST: formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'ICMSST')[0]),
                percentualDesconto: 0,
                desconto: 0,
                solicitacao: itemMap.C1_NUM,
                itemSolicitacao: itemMap.C1_ITEM,
                anexoItem: itemMap.C1_XANEXO.trim() || '[]',
                tipoProduto: isServico,
                opcoesContaContabil: contabil,
                tipoCentroCusto: itemMap.CTT_XTIPO.trim(),
                deletado: false,
                C1_XANEXO: itemMap.C1_XANXSC.trim() || '[]'
            }

            return item
        });
    }

    useEffect( ()=> {
        calculaTotais();
    }, [dataItensPedido, campoDesconto, campoValorFrete])

    const handleAlterarItem = (item) => {
        let cConsulta = retornaConsultaCentroCusto(item.campoCentroCusto.value)
        setIsSolicitacao(!(item.solicitacao === ''))
        //Clear Campos
        setCampoItem(item.item)
        setCampoProduto(item.produto);
        setCampoUnidade(item.unidadeMedida);
        setCampoDescricaoComplementar(item.descricaoComplementar);
        setCampoQuantidade(formatarComoDecimal(parseLocaleNumber(item.quantidade),4));
        setCampoValorUnitario(formatarMoeda2(parseLocaleNumber(item.valorUnitario),4));
        setCampoValorTotal(formatarMoeda2(parseLocaleNumber(item.valorTotal),2));
        setCampoCA(item.certificado);
        setCampoNumeroNF(item.numeroNF)
        setCampoArmazem(item.campoArmazem);
        setCampoContaContabil(item.campoContaContabil);
        setCampoCentroCusto(item.campoCentroCusto);
        setCampoCentroCustoReposicao(item.campoCentroCustoReposicao);
        setCampoEnderecoEntrega(item.enderecoEntrega);
        setCampoAnexosItem(JSON.parse(item.anexoItem));
        setCampoBaseICMS(formatarMoeda2(parseLocaleNumber(item.icms.BASE),2));
        setCampoAliquotaICMS(formatarMoeda2(parseLocaleNumber(item.icms.ALIQUOTA),2));
        setCampoValorICMS(formatarMoeda2(parseLocaleNumber(item.icms.VALOR),2));
        setCampoBaseIPI(formatarMoeda2(parseLocaleNumber(item.ipi.BASE),2));
        setCampoAliquotaIPI(formatarMoeda2(parseLocaleNumber(item.ipi.ALIQUOTA),2));
        setCampoValorIPI(formatarMoeda2(parseLocaleNumber(item.ipi.VALOR),2));
        setCampoBasePIS(formatarMoeda2(parseLocaleNumber(item.pis.BASE),2));
        setCampoAliquotaPIS(formatarMoeda2(parseLocaleNumber(item.pis.ALIQUOTA),2));
        setCampoValorPIS(formatarMoeda2(parseLocaleNumber(item.pis.VALOR),2));
        setCampoBaseCOFINS(formatarMoeda2(parseLocaleNumber(item.cofins.BASE),2));
        setCampoAliquotaCOFINS(formatarMoeda2(parseLocaleNumber(item.cofins.ALIQUOTA),2));
        setCampoValorCOFINS(formatarMoeda2(parseLocaleNumber(item.cofins.VALOR),2));
        setCampoBaseISS(formatarMoeda2(parseLocaleNumber(item.iss.BASE),2));
        setCampoAliquotaISS(formatarMoeda2(parseLocaleNumber(item.iss.ALIQUOTA),2));
        setCampoValorISS(formatarMoeda2(parseLocaleNumber(item.iss.VALOR),2));
        setCampoBaseIRRF(formatarMoeda2(parseLocaleNumber(item.irrf.BASE),2));
        setCampoAliquotaIRRF(formatarMoeda2(parseLocaleNumber(item.irrf.ALIQUOTA),2));
        setCampoValorIRRF(formatarMoeda2(parseLocaleNumber(item.irrf.VALOR),2));
        setCampoBaseINSS(formatarMoeda2(parseLocaleNumber(item.inss.BASE),2));
        setCampoAliquotaINSS(formatarMoeda2(parseLocaleNumber(item.inss.ALIQUOTA),2));
        setCampoValorINSS(formatarMoeda2(parseLocaleNumber(item.inss.VALOR),2));
        setCampoBaseCSLL(formatarMoeda2(parseLocaleNumber(item.csll.BASE),2));
        setCampoAliquotaCSLL(formatarMoeda2(parseLocaleNumber(item.csll.ALIQUOTA),2));
        setCampoValorCSLL(formatarMoeda2(parseLocaleNumber(item.csll.VALOR),2));
        setCampoBaseDIFAL(formatarMoeda2(parseLocaleNumber(item.difal.BASE),2));
        setCampoAliquotaDIFAL(formatarMoeda2(parseLocaleNumber(item.difal.ALIQUOTA),2));
        setCampoValorDIFAL(formatarMoeda2(parseLocaleNumber(item.difal.VALOR),2));
        setCampoBaseICMSST(formatarMoeda2(parseLocaleNumber(item.icmsST.BASE),2));
        setCampoAliquotaICMSST(formatarMoeda2(parseLocaleNumber(item.icmsST.ALIQUOTA),2));
        setCampoValorICMSST(formatarMoeda2(parseLocaleNumber(item.icmsST.VALOR),2));

        setOpcoesContaContabil(item.opcoesContaContabil)
        setTipoProduto(item.tipoProduto)
        setTipoCentroCusto(item.tipoCentroCusto)
        setQueryCentroCusto(cConsulta)
        setQueryCentroCustoReposicao(cConsulta.replace('CTT_CUSTO =', 'CTT_CUSTO !='))
        setHabilitaItem(true)
    }

    const handleExcluirItem = (item) => {
        const id = item.item;

        setDataItensPedido((prevData) => 
            prevData.map((item) => {
                if (item.item === id){
                    return { ...item, deletado: true };
                }else{
                    return item;
                }
            })
        );
    }

    const handleSalvar = async() =>{
        setCarregar(true)
        let cJSONSalvar;
        let oRetorno
        const dataItensSalvar = dataItensPedido.map((item) => { 
            const nTotalProduto = parseLocaleNumber(item.valorTotal)
            const descontoItem = parseLocaleNumber(campoDesconto) > 0 ? parseFloat((nTotalProduto * (parseLocaleNumber(campoDesconto)/100)).toFixed(2),2) : 0;
            //const totalItem = parseFloat((nTotalProduto - descontoItem).toFixed(2),2)
			const totalItem = parseFloat((nTotalProduto).toFixed(2),2)

            item.numero = campoNumero;
            item.fornecedor = campoFornecedor;
            item.emissao = campoDataEmissao;
            item.entrega = campoDataNecessidade;
            item.comprador = campoComprador;
            item.finalidade = campoTipoCompra;
            item.prioridade = campoPrioridade;
            item.condicaoPagamento = campoCondicaoPagamento
            item.enviaEmail = campoEnviaEmail.value
            item.moeda = campoMoeda
            item.tipoFrete = campoTipoFrete;
            item.valorFrete = parseLocaleNumber(campoValorFrete);
            item.desconto = descontoItem;
            item.percentualDesconto = parseLocaleNumber(campoDesconto);
            item.justificativa = campoJustificativaComprador; 
            item.observacao = campoObservacaoFornecedor; 
            item.anexoPC = JSON.stringify(campoAnexos); 
            item.totalItem = totalItem;

            return item
        })
        
        if (dataItensSalvar.length > 0){
            cJSONSalvar = JSON.stringify(dataItensSalvar)
        }        
        
        if (campoNumero){
            oRetorno = await ConsumoTOTVS_POST('ALTERARPEDIDOCOMPRAS', cJSONSalvar, empresaFilial)
        }else{
            oRetorno = await ConsumoTOTVS_POST('NOVOPEDIDOCOMPRAS', cJSONSalvar, empresaFilial)
        }
        
        setCarregar(false)

        if (oRetorno.error === '00'){
            SucessoMsg(oRetorno.description)
        }else{
            ErroMsg(oRetorno.description)
            return false;
        }

    }

    const handleCampoNumeroNF = () => {
        const value = campoNumeroNF.trim().padStart(9, '0');
        
        setCampoNumeroNF(value);
    }

    const handleICMS = (tipoCampo, valor) => {
        switch (tipoCampo) {
            case 'B':
                setCampoBaseICMS(valor)

                if (parseLocaleNumber(campoAliquotaICMS) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * Number(parseLocaleNumber(campoAliquotaICMS)) / 100),2);
                    setCampoValorICMS(newValor)
                }
                break;
            case 'A':
                setCampoAliquotaICMS(valor)

                if (parseLocaleNumber(campoBaseICMS) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(campoBaseICMS)) * Number(parseLocaleNumber(valor)) / 100),2);
                    setCampoValorICMS(newValor)
                }
                break;
            case 'V':
                setCampoValorICMS(valor)

                if (parseLocaleNumber(campoBaseICMS) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * 100 / Number(parseLocaleNumber(campoBaseICMS))),2);
                    setCampoAliquotaICMS(newValor)
                }
                break;
            default:
                break;
        }
    }

    const handleIPI = (tipoCampo, valor) => {
        switch (tipoCampo) {
            case 'B':
                setCampoBaseIPI(valor)

                if (parseLocaleNumber(campoAliquotaIPI) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * Number(parseLocaleNumber(campoAliquotaIPI)) / 100),2);
                    setCampoValorIPI(newValor)
                }
                break;
            case 'A':
                setCampoAliquotaIPI(valor)

                if (parseLocaleNumber(campoBaseIPI) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(campoBaseIPI)) * Number(parseLocaleNumber(valor)) / 100),2);
                    setCampoValorIPI(newValor)
                }
                break;
            case 'V':
                setCampoValorIPI(valor)

                if (parseLocaleNumber(campoBaseIPI) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * 100 / Number(parseLocaleNumber(campoBaseIPI))),2);
                    setCampoAliquotaIPI(newValor)
                }
                break;
            default:
                break;
        }
    }

    const handlePIS = (tipoCampo, valor) => {
        switch (tipoCampo) {
            case 'B':
                setCampoBasePIS(valor)

                if (parseLocaleNumber(campoAliquotaPIS) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * Number(parseLocaleNumber(campoAliquotaPIS)) / 100),2);
                    setCampoValorPIS(newValor)
                }
                break;
            case 'A':
                setCampoAliquotaPIS(valor)

                if (parseLocaleNumber(campoBasePIS) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(campoBasePIS)) * Number(parseLocaleNumber(valor)) / 100),2);
                    setCampoValorPIS(newValor)
                }
                break;
            case 'V':
                setCampoValorPIS(valor)

                if (parseLocaleNumber(campoBasePIS) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * 100 / Number(parseLocaleNumber(campoBasePIS))),2);
                    setCampoAliquotaPIS(newValor)
                }
                break;
            default:
                break;
        }
    }

    const handleCOFINS = (tipoCampo, valor) => {
        switch (tipoCampo) {
            case 'B':
                setCampoBaseCOFINS(valor)

                if (parseLocaleNumber(campoAliquotaCOFINS) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * Number(parseLocaleNumber(campoAliquotaCOFINS)) / 100),2);
                    setCampoValorCOFINS(newValor)
                }
                break;
            case 'A':
                setCampoAliquotaCOFINS(valor)

                if (parseLocaleNumber(campoBaseCOFINS) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(campoBaseCOFINS)) * Number(parseLocaleNumber(valor)) / 100),2);
                    setCampoValorCOFINS(newValor)
                }
                break;
            case 'V':
                setCampoValorCOFINS(valor)

                if (parseLocaleNumber(campoBaseCOFINS) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * 100 / Number(parseLocaleNumber(campoBaseCOFINS))),2);
                    setCampoAliquotaCOFINS(newValor)
                }
                break;
            default:
                break;
        }
    }

    const handleISS = (tipoCampo, valor) => {
        switch (tipoCampo) {
            case 'B':
                setCampoBaseISS(valor)

                if (parseLocaleNumber(campoAliquotaISS) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * Number(parseLocaleNumber(campoAliquotaISS)) / 100),2);
                    setCampoValorISS(newValor)
                }
                break;
            case 'A':
                setCampoAliquotaISS(valor)

                if (parseLocaleNumber(campoBaseISS) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(campoBaseISS)) * Number(parseLocaleNumber(valor)) / 100),2);
                    setCampoValorISS(newValor)
                }
                break;
            case 'V':
                setCampoValorISS(valor)

                if (parseLocaleNumber(campoBaseISS) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * 100 / Number(parseLocaleNumber(campoBaseISS))),2);
                    setCampoAliquotaISS(newValor)
                }
                break;
            default:
                break;
        }
    }

    const handleIRRF = (tipoCampo, valor) => {
        switch (tipoCampo) {
            case 'B':
                setCampoBaseIRRF(valor)

                if (parseLocaleNumber(campoAliquotaIRRF) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * Number(parseLocaleNumber(campoAliquotaIRRF)) / 100),2);
                    setCampoValorIRRF(newValor)
                }
                break;
            case 'A':
                setCampoAliquotaIRRF(valor)

                if (parseLocaleNumber(campoBaseIRRF) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(campoBaseIRRF)) * Number(parseLocaleNumber(valor)) / 100),2);
                    setCampoValorIRRF(newValor)
                }
                break;
            case 'V':
                setCampoValorIRRF(valor)

                if (parseLocaleNumber(campoBaseIRRF) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * 100 / Number(parseLocaleNumber(campoBaseIRRF))),2);
                    setCampoAliquotaIRRF(newValor)
                }
                break;
            default:
                break;
        }
    }

    const handleINSS = (tipoCampo, valor) => {
        switch (tipoCampo) {
            case 'B':
                setCampoBaseINSS(valor)

                if (parseLocaleNumber(campoAliquotaINSS) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * Number(parseLocaleNumber(campoAliquotaINSS)) / 100),2);
                    setCampoValorINSS(newValor)
                }
                break;
            case 'A':
                setCampoAliquotaINSS(valor)

                if (parseLocaleNumber(campoBaseINSS) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(campoBaseINSS)) * Number(parseLocaleNumber(valor)) / 100),2);
                    setCampoValorINSS(newValor)
                }
                break;
            case 'V':
                setCampoValorINSS(valor)

                if (parseLocaleNumber(campoBaseINSS) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * 100 / Number(parseLocaleNumber(campoBaseINSS))),2);
                    setCampoAliquotaINSS(newValor)
                }
                break;
            default:
                break;
        }
    }

    const handleCSLL = (tipoCampo, valor) => {
        switch (tipoCampo) {
            case 'B':
                setCampoBaseCSLL(valor)

                if (parseLocaleNumber(campoAliquotaCSLL) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * Number(parseLocaleNumber(campoAliquotaCSLL)) / 100),2);
                    setCampoValorCSLL(newValor)
                }
                break;
            case 'A':
                setCampoAliquotaCSLL(valor)

                if (parseLocaleNumber(campoBaseCSLL) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(campoBaseCSLL)) * Number(parseLocaleNumber(valor)) / 100),2);
                    setCampoValorCSLL(newValor)
                }
                break;
            case 'V':
                setCampoValorCSLL(valor)

                if (parseLocaleNumber(campoBaseCSLL) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * 100 / Number(parseLocaleNumber(campoBaseCSLL))),2);
                    setCampoAliquotaCSLL(newValor)
                }
                break;
            default:
                break;
        }
    }

    const handleDIFAL = (tipoCampo, valor) => {
        switch (tipoCampo) {
            case 'B':
                setCampoBaseDIFAL(valor)

                if (parseLocaleNumber(campoAliquotaDIFAL) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * Number(parseLocaleNumber(campoAliquotaDIFAL)) / 100),2);
                    setCampoValorDIFAL(newValor)
                }
                break;
            case 'A':
                setCampoAliquotaDIFAL(valor)

                if (parseLocaleNumber(campoBaseDIFAL) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(campoBaseDIFAL)) * Number(parseLocaleNumber(valor)) / 100),2);
                    setCampoValorDIFAL(newValor)
                }
                break;
            case 'V':
                setCampoValorDIFAL(valor)

                if (parseLocaleNumber(campoBaseDIFAL) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * 100 / Number(parseLocaleNumber(campoBaseDIFAL))),2);
                    setCampoAliquotaDIFAL(newValor)
                }
                break;
            default:
                break;
        }
    }

    const handleICMSST = (tipoCampo, valor) => {
        switch (tipoCampo) {
            case 'B':
                setCampoBaseICMSST(valor)
                
                if (parseLocaleNumber(campoAliquotaICMSST) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * Number(parseLocaleNumber(campoAliquotaICMSST)) / 100),2);
                    setCampoValorICMSST(newValor)
                }
                
                break;
            case 'A':
                setCampoAliquotaICMSST(valor)

                if (parseLocaleNumber(campoBaseICMSST) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(campoBaseICMSST)) * Number(parseLocaleNumber(valor)) / 100),2);
                    setCampoValorICMSST(newValor)
                }

                break;
            case 'V':
                setCampoValorICMSST(valor)

                if (parseLocaleNumber(campoBaseICMSST) > 0){
                    const newValor = formatarMoeda2((Number(parseLocaleNumber(valor)) * 100 / Number(parseLocaleNumber(campoBaseICMSST))),2);
                    setCampoAliquotaICMSST(newValor)
                }
                break;
            default:
                break;
        }
    }

    const handleTipoFrete = (e) => {
        setCampoTipoFrete(e);

        if (e?.value !== 'F'){
            setCampoValorFrete(formatarMoeda2(0,2))
        }
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePageTotvs 
                        text={`Pedidos de Compras ${isFormVisual ? ' - ' + idPedidoCompra : ''}`}
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial && (
                <>
                    <Row>
                        <Col md="10" xs="12">
                            <h5>Dados do PC: </h5>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Numero"
                                placeholder="Numero"
                                tipo="text"
                                value={campoNumero}
                                onChange={(e) => setCampoNumero(e)}
                                disabled={true}
                            />
                        </Col>
                        <Col md="6" xs="12">
                            <SelectFornecedor
                                campoFornecedor={campoFornecedor}
                                changeFornecedor={setCampoFornecedor}
                                empresaLogada={empresaFilial}
                                // disabled={campoNumero}
                            />
                        </Col>                    
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Data de Emissão"
                                placeholder="Data de Emissão"
                                tipo="date"
                                value={campoDataEmissao}
                                onChange={(e) => setCampoDataEmissao(e.target.value)}
                                disabled={campoNumero}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Previsão Entrega"
                                placeholder="Previsão Entrega"
                                tipo="date"
                                value={campoDataNecessidade}
                                onChange={(e) => setCampoDataNecessidade(e.target.value)}
                            />
                        </Col>
                        <Col md="6" xs="12">
                            <SelectComprador
                                campoComprador={campoComprador}
                                changeComprador={setCampoComprador}
                                empresaLogada={empresaFilial}
                                disabled={disabledComprador}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <SelectFinalidade
                                campoFinalidade={campoTipoCompra}
                                changeFinalidade={setCampoTipoCompra}
                                empresaLogada={empresaFilial}
                                returnOriginal={true}
                                disabled={disabledForm}
                                filtraFilial={true}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <SelectFixo
                                options={options} 
                                value={campoPrioridade} 
                                selectedOptionValue={campoPrioridade} 
                                isLabel={true} 
                                label="Prioridade" 
                                onChange={setCampoPrioridade}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <SelectFixo
                                options={[{value:' ', text:'Enviar'},{value:'N', text:'Não Enviar'}]} 
                                value={campoEnviaEmail} 
                                selectedOptionValue={campoEnviaEmail} 
                                isLabel={true} 
                                label="Enviar E-mail" 
                                onChange={(e) => setCampoEnviaEmail(e)}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectCondicaoPagamento
                                campoCondPagto={campoCondicaoPagamento}
                                changeCondPagto={setCampoCondicaoPagamento}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <SelectMoeda
                                campoMoeda={campoMoeda}
                                changeMoeda={setCampoMoeda}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <SelectFixo 
                                options={[{
                                    value: 'C',
                                    text: "CIF",
                                },
                                {
                                    value: 'F',
                                    text: "FOB",
                                }]}
                                isLabel={true} 
                                label="Tipo Frete"
                                onChange={handleTipoFrete}
                                selectedOptionValue={campoTipoFrete}
                                value={campoTipoFrete}
                            />
                        </Col>
                    </Row>

                    <HRDivider/>
                    <Row>
                        <Col md="8" xs="12">
                            <h5>Itens do Pedido: </h5>
                        </Col>
                        { !habilitaItem && campoFornecedor?.value && campoTipoCompra?.value && !disabledForm && !propIdPedidoCompra && (
                            <>
                                <Col md="2" xs="12" >
                                    <Button variant="primary" className="w-100" onClick={handleNewItem}>
                                        { '✚ Adicionar' }
                                    </Button>
                                </Col>
                                <Col md="2" xs="12" >
                                    <Button variant="primary" className="w-100" onClick={handleVincularItem}>
                                        { '🔗 Vincular SC' }
                                    </Button>
                                </Col>
                            </>
                        )}
                    </Row>

                    { habilitaItem && campoFornecedor?.value && campoTipoCompra?.value && (
                        <>
                            <Row>
                                <Col md="2" xs="12">
                                    <InputGeral
                                        label="Item"
                                        placeholder="Item"
                                        tipo="text"
                                        value={campoItem}
                                        onChange={setCampoItem}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md="8" xs="12">
                                    <BuscaProduto
                                        empresaFilial={empresaFilial} 
                                        handleProduto={handleProduto} 
                                        campoProduto={campoProduto}
                                        queryComplemento={queryProduto}
                                        disabled={isSolicitacao}
                                    />
                                </Col>
                                <Col md="2" xs="12">
                                    <InputGeral
                                        label="Unid. Medida"
                                        placeholder="U.Medida"
                                        tipo="text"
                                        value={campoUnidade}
                                        onChange={setCampoUnidade}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12" xs="12">
                                    <InputGeral
                                        label="Descrição Complementar do Produto"
                                        placeholder="Descrição Complementar do Produto"
                                        tipo="text"
                                        value={campoDescricaoComplementar}
                                        onChange={(e, value) => setCampoDescricaoComplementar(value)}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" xs="12">
                                    <SelectArmazem
                                        campoLocalEstoque={campoArmazem}
                                        changeLocalEstoque={handleArmazem}
                                        empresaLogada={empresaFilial}
                                        filtraFilial={true}
                                        returnOriginal={true}
                                        disabled={isSolicitacao}
                                    />
                                </Col>
                                <Col md="6" xs="12">
                                    <SelectContaContabil
                                        campoContaContabil={campoContaContabil}
                                        changeContaContabil={setCampoContaContabil}
                                        queryContaContabil={queryContaContabil}
                                        empresaLogada={empresaFilial}
                                        disabled={true}
                                        loadDefault={true}
                                        selectUnique={true}
                                    />
                                </Col>
                                <Col md="6" xs="12">
                                    <SelectCentroCusto
                                        campoCentroCusto={campoCentroCusto}
                                        changeCentroCusto={handleCampoCentroCusto}
                                        empresaLogada={empresaFilial}
                                        queryCentroCusto={queryCentroCusto}
                                        loadDefault={false}
                                        returnOriginal={true}
                                        disabled={true}
                                        filtraFilial={true}
                                    />
                                </Col>
                                { campoPrioridade.value === '5' &&
                                    <Col md="6" xs="12">
                                        <SelectCentroCusto 
                                            label="Centro de Custo de Reposição"
                                            campoCentroCusto={campoCentroCustoReposicao}
                                            changeCentroCusto={handleCampoCentroCustoReposicao}
                                            empresaLogada={empresaFilial}
                                            queryCentroCusto={queryCentroCustoReposicao}
                                            loadDefault={false}
                                            returnOriginal={true}
                                            disabled={isSolicitacao}
                                            filtraFilial={true}
                                        />
                                    </Col>
                                }
                                <Col md="12" xs="12">
                                    <InputGeral
                                        label="Endereço de Entrega"
                                        placeholder="Endereço de Entrega"
                                        tipo="text"
                                        value={campoEnderecoEntrega}
                                        onChange={(e, value) => setCampoEnderecoEntrega(value)}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md="3" xs="12">
                                    <InputGeral
                                        label="Quantidade"
                                        placeholder="Quantidade"
                                        tipo="monetario"
                                        value={campoQuantidade}
                                        onChange={handleCampoQuantidade}
                                        handleBlur={handleBlurImposto}
                                        disabled={isSolicitacao}
                                    />
                                </Col>
                                <Col md="3" xs="12">
                                    <InputGeral
                                        label="Valor Unitário"
                                        placeholder="Valor Unitário"
                                        tipo="monetario"
                                        value={campoValorUnitario}
                                        onChange={handleCampoValorUnitario}
                                        handleBlur={handleBlurImposto}
                                        decimal={4}
                                    />
                                </Col>
                                <Col md="3" xs="12">
                                    <InputGeral
                                        label="Valor Total"
                                        placeholder="Valor Total"
                                        tipo="monetario"
                                        value={campoValorTotal}
                                        onChange={setCampoValorTotal}
                                        disabled={true}
                                        decimal={2}
                                    />
                                </Col>
                                { campoPrioridade && campoPrioridade.value === '2' && (
                                    <Col md="3" xs="12">
                                        <InputGeral
                                            label="Numero NF"
                                            placeholder="Numero NF"
                                            tipo="text"
                                            value={campoNumeroNF}
                                            handleBlur={handleCampoNumeroNF}
                                            onChange={(e) => setCampoNumeroNF(e.target.value)}
                                            max={9}
                                        />
                                    </Col>
                                )}
                                { campoTipoCompra && campoTipoCompra.value === window._env_?.REACT_APP_FINALIDADE_EPI && (
                                    <Col md="3" xs="12">
                                        <InputGeral
                                            label={"CA"}
                                            placeholder={"Certificado de Aprovação"}
                                            tipo="text"
                                            value={campoCA}
                                            onChange={(e) => setCampoCA(e.target.value)}                                            
                                        />
                                    </Col>
                                )}
                                <Col md="12" xs="12">
                                    <h5>Impostos: </h5>
                                </Col>
                                    <Col md="2" xs="12">
                                        <InputGeral
                                            label="Base ICMS"
                                            placeholder="Base ICMS"
                                            tipo="monetario"
                                            value={campoBaseICMS}
                                            onChange={(e,value) => handleICMS('B', value)}
                                        />
                                    </Col>
                                    <Col md="2" xs="12">
                                        <InputGeral
                                            label="% ICMS"
                                            placeholder="Aliquota ICMS"
                                            tipo="monetario"
                                            value={campoAliquotaICMS}
                                            onChange={(e,value) => handleICMS('A', value)}
                                            decimal={4}
                                        />
                                    </Col>
                                    <Col md="2" xs="12">
                                        <InputGeral
                                            label="Valor ICMS"
                                            placeholder="Valor ICMS"
                                            tipo="monetario"
                                            value={campoValorICMS}
                                            onChange={(e,value) => handleICMS('V', value)}
                                            decimal={2}
                                        />
                                    </Col>
                                { tipoProduto === false && (
                                    <>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="Base IPI"
                                                placeholder="Base IPI"
                                                tipo="monetario"
                                                value={campoBaseIPI}
                                                onChange={(e,value) => handleIPI('B', value)}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="% IPI"
                                                placeholder="Aliquota IPI"
                                                tipo="monetario"
                                                value={campoAliquotaIPI}
                                                onChange={(e,value) => handleIPI('A', value)}
                                                decimal={4}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="Valor IPI"
                                                placeholder="Valor IPI"
                                                tipo="monetario"
                                                value={campoValorIPI}
                                                onChange={(e,value) => handleIPI('V', value)}
                                                decimal={2}
                                            />
                                        </Col>
                                    </>
                                )}
                                <Col md="2" xs="12">
                                    <InputGeral
                                        label="Base PIS"
                                        placeholder="Base PIS"
                                        tipo="monetario"
                                        value={campoBasePIS}
                                        onChange={(e,value) => handlePIS('B', value)}
                                    />
                                </Col>
                                <Col md="2" xs="12">
                                    <InputGeral
                                        label="% PIS"
                                        placeholder="Aliquota PIS"
                                        tipo="monetario"
                                        value={campoAliquotaPIS}
                                        onChange={(e,value) => handlePIS('A', value)}
                                        decimal={4}
                                    />
                                </Col>
                                <Col md="2" xs="12">
                                    <InputGeral
                                        label="Valor PIS"
                                        placeholder="Valor PIS"
                                        tipo="monetario"
                                        value={campoValorPIS}
                                        onChange={(e,value) => handlePIS('V', value)}
                                        decimal={2}
                                    />
                                </Col>
                                <Col md="2" xs="12">
                                    <InputGeral
                                        label="Base COFINS"
                                        placeholder="Base COFINS"
                                        tipo="monetario"
                                        value={campoBaseCOFINS}
                                        onChange={(e,value) => handleCOFINS('B', value)}
                                    />
                                </Col>
                                <Col md="2" xs="12">
                                    <InputGeral
                                        label="% COFINS"
                                        placeholder="Aliquota COFINS"
                                        tipo="monetario"
                                        value={campoAliquotaCOFINS}
                                        onChange={(e,value) => handleCOFINS('A', value)}
                                        decimal={4}
                                    />
                                </Col>
                                <Col md="2" xs="12">
                                    <InputGeral
                                        label="Valor COFINS"
                                        placeholder="Valor COFINS"
                                        tipo="monetario"
                                        value={campoValorCOFINS}
                                        onChange={(e,value) => handleCOFINS('V', value)}
                                        decimal={2}
                                    />
                                </Col>
                                { tipoProduto === true && (
                                    <>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="Base ISS"
                                                placeholder="Base ISS"
                                                tipo="monetario"
                                                value={campoBaseISS}
                                                onChange={(e,value) => handleISS('B', value)}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="% ISS"
                                                placeholder="Aliquota ISS"
                                                tipo="monetario"
                                                value={campoAliquotaISS}
                                                onChange={(e,value) => handleISS('A', value)}
                                                decimal={4}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="Valor ISS"
                                                placeholder="Valor ISS"
                                                tipo="monetario"
                                                value={campoValorISS}
                                                onChange={(e,value) => handleISS('V', value)}
                                                decimal={2}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="Base IRRF"
                                                placeholder="Base IRRF"
                                                tipo="monetario"
                                                value={campoBaseIRRF}
                                                onChange={(e,value) => handleIRRF('B', value)}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="% IRRF"
                                                placeholder="Aliquota IRRF"
                                                tipo="monetario"
                                                value={campoAliquotaIRRF}
                                                onChange={(e,value) => handleIRRF('A', value)}
                                                decimal={4}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="Valor IRRF"
                                                placeholder="Valor IRRF"
                                                tipo="monetario"
                                                value={campoValorIRRF}
                                                onChange={(e,value) => handleIRRF('V', value)}
                                                decimal={2}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="Base INSS"
                                                placeholder="Base INSS"
                                                tipo="monetario"
                                                value={campoBaseINSS}
                                                onChange={(e,value) => handleINSS('B', value)}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="% INSS"
                                                placeholder="Aliquota INSS"
                                                tipo="monetario"
                                                value={campoAliquotaINSS}
                                                onChange={(e,value) => handleINSS('A', value)}
                                                decimal={4}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="Valor INSS"
                                                placeholder="Valor INSS"
                                                tipo="monetario"
                                                value={campoValorINSS}
                                                onChange={(e,value) => handleINSS('V', value)}
                                                decimal={2}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="Base CSLL"
                                                placeholder="Base CSLL"
                                                tipo="monetario"
                                                value={campoBaseCSLL}
                                                onChange={(e,value) => handleCSLL('B', value)}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="% CSLL"
                                                placeholder="Aliquota CSLL"
                                                tipo="monetario"
                                                value={campoAliquotaCSLL}
                                                onChange={(e,value) => handleCSLL('A', value)}
                                                decimal={4}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="Valor CSLL"
                                                placeholder="Valor CSLL"
                                                tipo="monetario"
                                                value={campoValorCSLL}
                                                onChange={(e,value) => handleCSLL('V', value)}
                                                decimal={2}
                                            />
                                        </Col>
                                    </>
                                )}
                                { tipoProduto === false && (
                                    <>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="Base DIFAL"
                                                placeholder="Base DIFAL"
                                                tipo="monetario"
                                                value={campoBaseDIFAL}
                                                onChange={(e,value) => handleDIFAL('B', value)}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="% DIFAL"
                                                placeholder="Aliquota DIFAL"
                                                tipo="monetario"
                                                value={campoAliquotaDIFAL}
                                                onChange={(e,value) => handleDIFAL('A', value)}
                                                decimal={4}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="Valor DIFAL"
                                                placeholder="Valor DIFAL"
                                                tipo="monetario"
                                                value={campoValorDIFAL}
                                                onChange={(e,value) => handleDIFAL('V', value)}
                                                decimal={2}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="Base ICMS-ST"
                                                placeholder="Base ICMS-ST"
                                                tipo="monetario"
                                                value={campoBaseICMSST}
                                                onChange={(e,value) => handleICMSST('B', value)}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="% ICMS-ST"
                                                placeholder="Aliquota ICMS-ST"
                                                tipo="monetario"
                                                value={campoAliquotaICMSST}
                                                onChange={(e,value) => handleICMSST('A', value)}
                                                decimal={4}
                                            />
                                        </Col>
                                        <Col md="2" xs="12">
                                            <InputGeral
                                                label="Valor ICMS-ST"
                                                placeholder="Valor ICMS-ST"
                                                tipo="monetario"
                                                value={campoValorICMSST}
                                                onChange={(e,value) => handleICMSST('V', value)}
                                                decimal={2}
                                            />
                                        </Col>
                                    </>
                                )}
                            </Row>
                            <Row>
                                <Col md="12" xs="12">
                                    <LabelInput>Anexo Item PC</LabelInput>
                                    <UploadFiles 
                                        onDropEvent={handleAddFiles}
                                        onDeleteEvent={handleDelFiles}
                                        value={campoAnexosItem}
                                        onChange={setCampoAnexosItem}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md="8" xs="12"></Col>
                                <Col md="2" xs="12" >
                                    <Button variant="primary" className="w-100" onClick={handleConfirmNewItem}>
                                        { '✓ Salvar' }
                                    </Button>
                                </Col>
                                <Col md="2" xs="12" >
                                    <Button variant="warning" className="w-100" onClick={handleFecharItem}>
                                        { '✗ Cancelar' }
                                    </Button>
                                </Col>
                            </Row>
                        </>
                    )}
                </>
            )}
            { dataItensPedido && dataItensPedido.length > 0 &&
                <TrelloBoard 
                    columns={columnsItensPedido} 
                    data={dataItensPedido.filter((item) => item.deletado === false)} 
                    titleLista="Item: "
                    columnsAditional={columnsAditional}
                    buttons= { disabledForm ? [] : 
                            [   {action: handleAlterarItem, label: "Alterar", icone: "MdOutlineEditNote", style: "outline-info"},
                                {action: handleExcluirItem, label: "Excluir", icone: "MdPlaylistRemove", style: "outline-danger" }
                            ]
                    }
                    mdColCard={3}
                    mdColCardOpen={12}
                    tamanhoCard="75lvh"
                />
            }
            { empresaFilial && (
                <>
                    <Row>
                        <Col md="3" xs="12">
                            <InputGeral
                                label="% Desconto 1"
                                placeholder="Percentual 1º Desconto"
                                tipo="monetario"
                                value={campoDesconto}
                                onChange={(e, value) => setCampoDesconto(value)}
                                decimal={4}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <InputGeral
                                label="Total Desconto"
                                placeholder="Desconto"
                                tipo="monetario"
                                value={campoValorDesconto}
                                onChange={(e) => setCampoValorDesconto(e)}
                                disabled={true}
                                decimal={4}
                            />
                        </Col>
                        { (!campoTipoFrete || campoTipoFrete?.value === 'C') && (
                            <Col md="3" xs="12"></Col>
                        )}
                        { campoTipoFrete && campoTipoFrete?.value !== 'C' && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Valor do Frete"
                                    placeholder="Valor do Frete"
                                    tipo="monetario"
                                    value={campoValorFrete}
                                    onChange={(e,value) => setCampoValorFrete(value)}
                                    decimal={2}
                                />
                            </Col>
                        )}
                        
                        <Col md="3" xs="12">
                            <InputGeral
                                label="Total Produtos"
                                placeholder="Total Produtos"
                                tipo="monetario"
                                value={campoValorTotalProdutos}
                                disabled={true}
                                onChange={(e) => setCampoValorTotalProdutos(e)}
                                decimal={2}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="9" xs="12"></Col>
                        <Col md="3" xs="12">
                            <InputGeral
                                label="Total Pedido"
                                placeholder="Total Pedido"
                                tipo="monetario"
                                value={campoTotalPedido}
                                disabled={true}
                                onChange={(e) => setCampoTotalPedido(e)}
                                decimal={2}
                            />
                        </Col>
                    </Row>
                    <Row>
                        { (campoTotalICMS > 0 || campoTotalIPI > 0 || campoTotalPIS > 0 || campoTotalCOFINS > 0 || campoTotalISS > 0 || campoTotalIRRF > 0 || campoTotalINSS > 0 || campoTotalCSLL > 0 || campoTotalDIFAL > 0 || campoTotalICMSST > 0) && (
                            <Col md="12" xs="12">
                                <h5>Total de Impostos Pedido: </h5>
                            </Col>
                        )}
                        { campoTotalICMS > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total ICMS"
                                    placeholder="Total de ICMS"
                                    tipo="monetario"
                                    value={campoTotalICMS}
                                    onChange={(e) => setCampoTotalICMS(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalIPI > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total IPI"
                                    placeholder="Total de IPI"
                                    tipo="monetario"
                                    value={campoTotalIPI}
                                    onChange={(e) => setCampoTotalIPI(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalPIS > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total PIS"
                                    placeholder="Total de PIS"
                                    tipo="monetario"
                                    value={campoTotalPIS}
                                    onChange={(e) => setCampoTotalPIS(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalCOFINS > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total COFINS"
                                    placeholder="Total de COFINS"
                                    tipo="monetario"
                                    value={campoTotalCOFINS}
                                    onChange={(e) => setCampoTotalCOFINS(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalISS > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total ISS"
                                    placeholder="Total de ISS"
                                    tipo="monetario"
                                    value={campoTotalISS}
                                    onChange={(e) => setCampoTotalISS(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalIRRF > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total IRRF"
                                    placeholder="Total de IRRF"
                                    tipo="monetario"
                                    value={campoTotalIRRF}
                                    onChange={(e) => setCampoTotalIRRF(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalINSS > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total INSS"
                                    placeholder="Total de INSS"
                                    tipo="monetario"
                                    value={campoTotalINSS}
                                    onChange={(e) => setCampoTotalINSS(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalCSLL > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total CSLL"
                                    placeholder="Total de CSLL"
                                    tipo="monetario"
                                    value={campoTotalCSLL}
                                    onChange={(e) => setCampoTotalCSLL(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalDIFAL > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total DIFAL"
                                    placeholder="Total de DIFAL"
                                    tipo="monetario"
                                    value={campoTotalDIFAL}
                                    onChange={(e) => setCampoTotalDIFAL(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalICMSST > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total ICMS-ST"
                                    placeholder="Total de ICMS-ST"
                                    tipo="monetario"
                                    value={campoTotalICMSST}
                                    onChange={(e) => setCampoTotalICMSST(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                    </Row>
                    <Row>
                        <Col md="6" xs="12">
                            <InputGeral
                                label="Justificativa Comprador"
                                placeholder="Detalhe a Justificativa do Comprador"
                                tipo="textArea"
                                value={campoJustificativaComprador}
                                onChange={(e) => setCampoJustificativaComprador(e.target.value)}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="6" xs="12">
                            <InputGeral
                                label="Observação Fornecedor"
                                placeholder="Descreva a Observação adicional ao Fornecedor"
                                tipo="textArea"
                                value={campoObservacaoFornecedor}
                                onChange={(e) => setCampoObservacaoFornecedor(e.target.value)}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <LabelInput>Anexo do Pedido</LabelInput>
                            <UploadFiles 
                                onDropEvent={handleAddFilesPC}
                                onDeleteEvent={handleDelFilesPC}
                                value={campoAnexos}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                </>
            )}
            { dataItensPedido && dataItensPedido.length > 0 && !propIdPedidoCompra &&
                <SubmitForm 
                    onSave={ disabledForm ? null : handleSalvar}
                    onCancel={ disabledForm ? null : 'handleVoltar'}
                    onVoltar={ disabledForm ? 'handleVoltar' : null}
                />
            }
        </>
    );
}

export default FichaPedidosCompra;